// ABOUTME: React Query hook for the signed-in user's server preferences (GET /me/preferences)
// ABOUTME: Returns the schema defaults until the server answers; isLoading and isError mark those as placeholders

import { type MePreferences, PREF_DEFAULTS } from '@alpha-finder/contracts/me-preferences';
import type { BrowserAuth } from '@boundarylab/auth/browser';
import { useQuery } from '@tanstack/react-query';
import { meApi } from '../lib/api/me';
import { auth as defaultAuth } from '../lib/auth-client';
import { useAuth } from './useAuth';

export const PREFERENCES_QUERY_KEY = ['me-preferences'] as const;

const PLACEHOLDER_PREFERENCES: MePreferences = { ...PREF_DEFAULTS, defaultPortfolioId: null };

export type Preferences = MePreferences & { isLoading: boolean; isError: boolean };

export function usePreferences(auth: BrowserAuth = defaultAuth): Preferences {
  const { status } = useAuth(auth);
  const { data, isPending, isError } = useQuery({
    queryKey: PREFERENCES_QUERY_KEY,
    queryFn: () => meApi.getPreferences(),
    enabled: status === 'signed_in',
    staleTime: 60_000,
  });

  const isLoading = status === 'loading' || (status === 'signed_in' && isPending);
  return { ...(data ?? PLACEHOLDER_PREFERENCES), isLoading, isError: isError && !data };
}
